module.exports = __webpack_public_path__ + "img/main_btn_menu1.c01a1973.png";